import { Directive, inject } from '@angular/core';
import { MeetingReminderService } from '../../../core/services/meeting-reminder.service';
import { MeetingReminder } from '../../../core/models/meeting-reminder.model';
import { ReminderSnoozeScope } from '../../../core/models/snooze-state.model';

@Directive()
export abstract class MeetingReminderBaseComponent {
  protected readonly reminderService = inject(MeetingReminderService);

  isRequestPending(reminderId: number): boolean {
    return this.reminderService.getIsPending(reminderId);
  }

  onStartSession(reminderId: number): void {
    this.reminderService.startMeeting(reminderId);
  }

  onStopSession(reminderId: number): void {
    this.reminderService.stopReminder(reminderId);
  }

  onDismiss(reminderId: number): void {
    this.reminderService.dismissReminder(reminderId);
  }

  onSnooze(scope: ReminderSnoozeScope, reminder: MeetingReminder): void {
    this.reminderService.snoozeReminder(reminder.id, scope, reminder.calendarEventId, reminder.meetingEnd.toISOString());
  }
}
